export const TIMEOUT_AGREMENTS = 600000; // 10 mins

export const PAGE = {
  LOGIN: "login",
  LOADING: "loading",
  AGREEMENT: "agreement",
  ABOUT_APP: "aboutapp",
  STOP_CODE: "stopcode",
  DIALOG: "dialog",
};
